import {Component, ElementRef, EventEmitter, NgZone, Output, Renderer2, ViewChild} from '@angular/core';
import {TStatusBar, Util} from "../../app/util";
import {Platform} from 'ionic-angular';

import {CONFIG} from "../../app/config";
import {TDevicerScan, TProfileTeam} from "../../app/enum";

import {LogadoService} from "../../providers/logado-service";
import {WebstorSetaPage} from "../../pages/sync/webstor-seta/webstor-seta";
import {MessageService} from "../../providers/message-service";

@Component({
    selector: 'webster',
    templateUrl: 'webster.html',
    providers: [],
})

export class Webster {

    TProfileTeam: any = TProfileTeam;

    config: any;
    websterData: any;
    websterOpen: boolean;

    webstorpage: any = null;

    settingOlha: boolean;

    logado: any;
    akkjson = (window as any).handappMainInstance.appjson;

    @ViewChild('websterHeader') websterHeader: ElementRef;
    @ViewChild('websterMiddle') websterMiddle: ElementRef;
    @ViewChild('websterButton') websterButton: ElementRef;
    @ViewChild('websterSetupe') websterSetupe: ElementRef;

    @Output('webster-tool') private _tool: EventEmitter<any> = new EventEmitter();

    constructor(private _element: ElementRef, public util: Util,
                public platform: Platform,
                public renderer: Renderer2, private ngZone: NgZone, public messageService: MessageService,
                public logadoService: LogadoService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.subscribeWebster();
        this.checkinChanged();

        this.messageService.get('webster.toggle').subscribe(data => this.toggle());

        setInterval(() => this.settingOlha = !this.settingOlha, 2000);

    }

    subscribeWebster() {

        this.renderer.addClass(this._element.nativeElement.parentElement, 'corcor-header');
        this.renderer.addClass(this._element.nativeElement.parentElement, 'corcor-header-webster');

        //Nao pinta pois o this.checkinChanged() faz isso!
        //this._element.nativeElement.parentElement.style.setProperty('--varBackcolor', this.config.colors.CorMilk);
        //this._element.nativeElement.parentElement.style.setProperty('--varFontcolor', this.config.colors.CorMenu);

    }

    directiveChanged(data?: any) {

        //Color
        this.websterData.corBack = 'CorLime';
        this.websterData.corFont = 'CorLime';

    }

    checkinChanged() {

        let checkin = this.akkjson.checkin;
        let branded = (checkin ? checkin.Branded : this.config.spotus);

        //Checkin-Status
        this._element.nativeElement.parentElement.style.setProperty('--varBackcolor', this.config.colors[branded.BrandedCora]);
        this._element.nativeElement.parentElement.style.setProperty('--varFontcolor', this.config.colors[this.config.negative(branded.BrandedCora)]);

        let cor = (!checkin || this.config.negative(branded.BrandedCora) == 'CorMilk');
        this.util.statusBarColor(cor ? TStatusBar.sbStyleLightContent : TStatusBar.sbStyleDefault);

        this.ngZone.run(() => {});

    }

    toggle() {

        //Open | Close
        this.websterOpen = !this.websterOpen;
        this.util.websterOpen = this.websterOpen;

        //Hide Support Button Fab
        (window as any).handappMainInstance.supportShow = !this.websterOpen;

        if (this.websterOpen) {

            this.util.impact();

            //Webstor... Load
            this.webstorpage = WebstorSetaPage;

            //this.websterMiddle.nativeElement.scrollTop = 0;
            //this.content.scrollTo(0, 0, this.content.getScrollElement().scrollTop ? 300 : 0, () => {

            //#GAMBI - PLUS -> No mobile ele fica muito grande o botão quando aberto pq soma safe-area-inset-bottom, so coloca para web
            let plus = (this.util.nativeApp() ? (this.platform.is('ios') ? 15 : 0) : 0);

            //let websterHeight: 0; //30;
            this.websterMiddle.nativeElement.style.height = (window.innerHeight - this.websterButton.nativeElement.offsetHeight + plus) + 'px';
            //this.websterMiddle.nativeElement.style.height = (window.innerHeight - this.websterHeader.nativeElement.offsetHeight - this.websterButton.nativeElement.offsetHeight) + 'px';
            //AKI -> this.websterMiddle.nativeElement.style.height = (window.innerHeight - this.websterHeader.nativeElement.offsetHeight - this.websterButton.nativeElement.offsetHeight - websterHeight) + 'px';
            //this.websterButton.nativeElement.style.position = 'absolute';
            this.websterButton.nativeElement.style.top = (window.innerHeight - this.websterButton.nativeElement.offsetHeight + plus) + 'px';
            //this.websterButton.nativeElement.style.height = (this.websterButton.nativeElement.offsetHeight + this.websterHeight) + 'px';

            this.ngZone.run(() => {});
            //setTimeout(() => {
            //this.websterMiddle.nativeElement.style.overflowY = 'auto';
            //this.content. getScrollElement().style.overflowY = 'hidden';
            //}, 300);

            //});


            (window as any).handappMainInstance.escutarTela(TDevicerScan.dsWorkday);


        } else {

            this.websterMiddle.nativeElement.style.height = '0';
            this.websterButton.nativeElement.style.top = '0';//websterHeight + 'px';
            //AKI -> this.websterButton.nativeElement.style.top = (this.websterHeader.nativeElement.offsetHeight) + 'px';
            //this.websterButton.nativeElement.style.height = (this.websterButton.nativeElement.offsetHeight - websterHeight) + 'px';

            this.ngZone.run(() => {});
            //this.websterMiddle.nativeElement.style.overflowY = 'hidden';
            //this.content.getScrollElement().style.overflowY = 'auto';

            //setTimeout(() => this.websterButton.nativeElement.style.position = 'static', 300);

            (window as any).handappMainInstance.escutarTela(TDevicerScan.dsEntraki);

        }

        //Setting
        if (this.websterSetupe) this.websterSetupe.nativeElement.style.top = this.websterButton.nativeElement.style.top;

    }

    settingOpen() {

        this._tool.emit();

    }

}



// WEBPACK FOOTER //
// ./src/components/webster/webster.ts